module.exports = __webpack_public_path__ + "img/login-dark.d785b366.svg";